export function getFormattedKey(str: string) {
  return str.split(' ').join('_').toLocaleLowerCase();
}
